import $ from 'jquery';

import {
	destroyiCheck,
	formatNumber
} from './utilities';

class BuyCourses {
	constructor(){
		// Check if we have to invoke the methods
		if ( this.isBuyCourses() ){
			// Get elements
			this.getElements();

			// Get configuration
			this.getConfiguration();

			// Destroy iCheck checkboxes
			destroyiCheck();

			// Listen changes in the checkboxes
			this.modifyCourses();

			// Listen changes to the quantity field
			this.listenQuantityChanges();

			// Listen the form submission
			this.listenFormSubmission();
		}
	}

	getElements(){
		// Get elements
		this.$elements = {
			form:               $( '#uo-groups-buy-courses' ),
			errorNotice:        $( '#uo-groups-buy-course-error-notice' ),
			field: {
				quantity:       $( '#uo-groups-buy-course-field-quantity' ),
			},
			totals: {
				subtotal:       $( '#uo-groups-buy-course-totals-subtotal' ),
				discount: {
					percentage: $( '#uo-groups-buy-course-totals-discount-percentage' ),
					total:      $( '#uo-groups-buy-course-totals-discount' ),
				},
				total:          $( '#uo-groups-buy-course-totals-total' ),
			}
		}
	}

	getConfiguration(){
		// Get bulk discount configuration
		let bulkDiscountData = this.$elements.form.data( 'bulk-discount' );
		// Check if it's bulk discount is enabled
		let bulkDiscountEnabled = bulkDiscountData.enabled == 'yes';
		// Check if there are discount groups
		bulkDiscountData.discounts = typeof bulkDiscountData.discounts !== 'undefined' ? bulkDiscountData.discounts : {};
		// Get discount groups
		let bulkDiscountGroups = [];
		$.each( Object.values( bulkDiscountData.discounts ), ( index, group ) => {
			bulkDiscountGroups.push({
				minimumQuantity: parseInt( group.qty ),
				percentage: parseFloat( group.percent )
			});
		});

		// Get configuration
		this.config = {
			bulkDiscount: {
				enabled: bulkDiscountEnabled,
				groups:  bulkDiscountGroups
			},
			formatPrice: {
				template:          ULG_BuyCourses.formatPrice.template,
				numberOfDecimals:  ULG_BuyCourses.formatPrice.numberOfDecimals,
				thousandSeparator: ULG_BuyCourses.formatPrice.thousandSeparator,
				decimalSeparator:  ULG_BuyCourses.formatPrice.decimalSeparator,
			}
		}

		// Get totals
		this.totals = {
			numberOfSeats: 0,
			numberOfStudents: 0,
			subtotal: 0,
			discount: {
				percentage: 0,
				total: 0
			},
			total: 0
		}
	}

	modifyCourses(){
		// Listen changes to the checkboxes
		this.$elements.form.on( 'change', '.uo-checkbox input', ( event ) => {
			// Get checkbox
			const $checkbox = $( event.currentTarget );

			// Get row
			const $row = $checkbox.closest( '.uo-groups-table-row' );

			// Toggle selected class
			$row.toggleClass( 'uo-groups-table-row--selected' );

			// Update totals
			this.updateTotals();
		});
	}

	listenFormSubmission(){
		// Listen form submission
		this.$elements.form.on( 'submit', ( event ) => {
			// Validate
			const validation = this.validate();

			// Show (or not) the error notice
			this.errorNotice( ! validation.isValid, validation.message );

			// Check if it's not valid
			if ( ! validation.isValid ){
				// Prevent default
				event.preventDefault();
			}	
		});
	}

	listenQuantityChanges(){
		// Listen quantity changes
		this.$elements.field.quantity.on( 'input', () => {
			// Update totals
			this.updateTotals();
		});
	}

	getTotals(){
		// Get and update number of selected courses
		const $selectedCourses = this.$elements.form.find( '.uo-checkbox input:checked' );
		// Update totals
		this.totals.numberOfSeats = parseInt( this.$elements.field.quantity.val() );
		// Check if the number if valid
		this.totals.numberOfSeats = isNaN( this.totals.numberOfSeats ) ? 1 : this.totals.numberOfSeats;

		// Get number of students
		let numberOfStudents = this.$elements.field.quantity.val();
		// Update totals
		this.totals.numberOfStudents = parseInt( numberOfStudents );

		// Get the number of selected courses
		this.totals.numberOfCourses = $selectedCourses.length;

		// Get subtotal
		let subtotal = numberOfStudents * $selectedCourses.toArray().reduce(( accumulator, course ) => {
			// Get jQuery object of the course
			const $course = $( course );

			// Get price
			const price = parseFloat( $course.data( 'price' ) );

			// Add price to the accumulator
			return accumulator + price;
		}, 0 );
		// Update totals
		this.totals.subtotal = subtotal;

		// Get discount
		// Get discount group
		const discountGroup = this.getDiscountPercentage();
		// Get discount
		let discount = -1 * subtotal * discountGroup.percentage / 100;
		// Update totals
		this.totals.discount.percentage = discountGroup.percentage;
		this.totals.discount.total = discount;

		// Get total
		let total = subtotal + discount;
		total = total > 0 ? total : 0;
		// Update totals
		this.totals.total = total;
	}

	getDiscountPercentage(){
		// We will get what discount we have to apply
		// To do that, we're going to find the discount group
		// using the current number of selected groups, searching
		// for the group with the highest minimum
		let discountGroup = {
			minimumQuantity: 0,
			percentage: 0
		}

		// Check if the user has discount groups
		if ( this.config.bulkDiscount.enabled ){
			// Iterate groups
			$.each( this.config.bulkDiscount.groups, ( index, group ) => {
				// Check if the minimum is lower (or equal) than our number of seats
				if ( group.minimumQuantity <= this.totals.numberOfSeats ){
					// Save group
					discountGroup = group;
				}
			});
		}

		// Return group
		return discountGroup;
	}

	updateTotals(){
		// Get totals
		this.getTotals();

		// Update subtotal
		this.$elements.totals.subtotal.html( this.formatPrice( this.totals.subtotal ) );
		
		// Update discount
		// If it's 0, remove percentage from the DOM
		if ( this.totals.discount.percentage == 0 ){
			this.$elements.totals.discount.percentage.text( '' );
		}
		// Otherwise, add it
		else {
			this.$elements.totals.discount.percentage.text( `${ this.totals.discount.percentage }% - ` );
		}
		this.$elements.totals.discount.total.html( this.formatPrice( this.totals.discount.total ) );

		// Update total
		this.$elements.totals.total.html( this.formatPrice( this.totals.total ) );

		// Add updated class
		this.$elements.form.addClass( 'uo-groups-buy-courses--totals-updated' );
		// Remove class after 150ms
		setTimeout(() => {
			this.$elements.form.removeClass( 'uo-groups-buy-courses--totals-updated' );
		}, 150 );
	}

	validate(){
		// Default value
		let response = {
			isValid: false,
			message: ''
		};

		// Check if there is at least one course selected
		if ( this.totals.numberOfSeats > 0 && this.totals.numberOfCourses > 0 ){
			// Update validation
			response.isValid = true;
		}
		else {
			// Otherwise, add message
			response.message = ULG_BuyCourses.i18n.selectAtLeastOne;
		}

		// Return response
		return response;
	}

	errorNotice( hasError = false, message = '' ){
		// Check if we have to show or hide the notice
		if ( hasError ){
			// Show notice
			this.$elements.errorNotice.show().html( message );
		}
		else {
			// Hide notice
			this.$elements.errorNotice.hide();
		}
	}

	formatPrice( price ){
		// Get price format
		const $price = $( this.config.formatPrice.template );

		// Replace dummy price with real price
		$price.html(( index, oldHtml ) => {
			// Get the number of wc_price( 0 )
			const dummyPrice = formatNumber( 0, this.config.formatPrice.numberOfDecimals, this.config.formatPrice.decimalSeparator, this.config.formatPrice.thousandSeparator );

			// Format real price
			const priceFormatted = formatNumber( price, this.config.formatPrice.numberOfDecimals, this.config.formatPrice.decimalSeparator, this.config.formatPrice.thousandSeparator );

			// Replace text
			return oldHtml.replace( dummyPrice, priceFormatted );  
		});

		// Check if the price is negative
		if ( price < 0 ){
			// Add minus character
			$price.prepend( '-' );
		}

		// Return price jQuery element
		return $price;
	}

	isBuyCourses(){
		return $( '#uo-groups-buy-courses' ).length == 1 && typeof ULG_BuyCourses !== 'undefined';
	}
}

export default BuyCourses;